// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Checnovskaya <anastasia.chesnovskaya@celadon.ae>

const styles = ({
  loaderContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 10,
  }
});

export default styles;
